const mutations = {
    setInfos(state,getInfo){
        state.userInfo=getInfo
    }
}
export default mutations